import { render, staticRenderFns } from "./SubmissionList.vue?vue&type=template&id=76a57e04&scoped=true&"
import script from "./SubmissionList.vue?vue&type=script&lang=js&"
export * from "./SubmissionList.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionList.vue?vue&type=style&index=0&id=76a57e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a57e04",
  null
  
)

export default component.exports